// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1AbvV","colMaxWidth":"Table_colMaxWidth__1D1Y3"};